<template>
  <v-card tile class="login-conteiner ma-0 pa-0">
    <vetalfa-email-component v-if="emailConfirmation"></vetalfa-email-component>
    <v-row
      class="ma-0 pa-0"
      align="center"
      align-content="center"
      justify="center"
      style="height: 35%"
    >
      <v-img
        position="center"
        class="ma-0 pa-0"
        :max-height="100"
        contain
        :max-width="200"
        :lazy-src="logo"
        :src="logo"
      ></v-img>
      <v-col cols="12" class="pa-0 ma-0">
        <p class="text-center ma-0 pa-0 mt-5 login-subtitle">
          {{ _getLabel("SLOGAN") }}
        </p>
      </v-col>
    </v-row>
    <v-row
      @click="openEmailDialog()"
      class="login-button-row mb-5 ma-0 pa-0"
      align="center"
      justify="center"
    >
      <v-col cols="8" class="ma-0 pa-0" style="max-width: 300px !important">
        <v-row align="center" class="login-button white ma-0 pa-0 px-3">
          <v-avatar class="ma-0 pa-0" size="18px" tile>
            <v-icon class="ma-0 pa-0" color="primary">{{
              mdiEmailOutline
            }}</v-icon>
          </v-avatar>
          <span class="ml-3 login-buton-text">{{
            _getLabel("LOGIN_EMAIL")
          }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="
        text-decoration-underline
        login-subtitle
        vetalfa-pointer
        mt-16
        mb-5
        ma-0
      "
      justify="center"
      @click="
        openExternalUrl({
          url: _getParameter('LOGIN_CHANGE'),
          inAppBrowser: true,
        })
      "
    >
      <span>
        {{ _getLabel("WHY_WE_CHANGED_OUR_LOGIN") }}
      </span>
    </v-row>
    <v-row justify="center" class="login-footer-text pa-0 ma-0">
      <p class="pa-0 ma-0">{{ _getLabel("LOGIN_FOOTER_TEXT_1") }}</p>
    </v-row>
    <v-row justify="center" class="login-footer-link pa-0 ma-0">
      <p class="pa-0 ma-0">
        <span
          @click="
            openExternalUrl({
              url: _getParameter('TERMS_URL'),
              inAppBrowser: true,
            })
          "
          class="pa-0 ma-0"
          style="text-decoration: underline !important"
          >{{ _getLabel("USE_TERMS_TITLE") }}</span
        >
        <span>{{ _getLabel("LOGIN_FOOTER_TEXT_2") }}</span>
        <span
          @click="
            openExternalUrl({
              url: _getParameter('POLICIES_URL'),
              inAppBrowser: true,
            })
          "
          class="pa-0 ma-0"
          style="text-decoration: underline !important"
          >{{ _getLabel("PRIVACY_POLICIES_TITLE") }}</span
        >
      </p>
    </v-row>
  </v-card>
</template>

<style>
.login-buton-text {
  padding-top: 4px;
  line-height: 16px;
}
.login-subtitle {
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
}
.login-logo {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 0;
}
.login-footer-text {
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 10px;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 47px;
}
.login-footer-link {
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 27px;
  cursor: pointer;
}
.login-conteiner {
  background: linear-gradient(90deg, #002f56, 39%, #00728a);
  height: 100%;
  width: 100%;
  overflow-y: hidden !important;
}
.login-button-row {
  cursor: pointer;
}
.login-button {
  color: #393a3a;
  font-size: 14px;
  letter-spacing: 0;
  height: 40px;
  border-radius: 5px;
}
</style>

<script>
import { mdiEmailOutline } from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import images from "@/constants/images.js";
import Email from "@/components/Email.vue";
export default {
  name: "Login",
  methods: {
    ...mapMutations("general", ["setEmailConfirmation"]),
    ...mapActions("general", ["openEmailDialog", "openExternalUrl"]),
  },
  components: {
    "vetalfa-email-component": Email,
  },
  computed: {
    ...mapGetters("general", ["emailConfirmation"]),
  },
  data() {
    return {
      logo: images.LOGO_LOGIN,
      mdiEmailOutline,
    };
  },
  mounted() {
    this.setEmailConfirmation(false);
  },
  created() {},
};
</script>
